<div class="card d-flex flex-column container" (click)="getMailThread(snippet.threadId)">
    <p>{{snippet.from}}</p>
    <p>{{snippet.date | date}}</p>
    <p>{{snippet.subject}}</p>
    <div class="block">

            <div *ngIf="snippet.isHtml" [innerHtml]="snippet.content"></div>
            <pre *ngIf="!snippet.isHtml">{{snippet.content}}</pre>
    </div>
</div>